<template>
    <nav class="navbar navbar-dark bg-primary py-3 navbar-fixed-top">
        <div class="container-fluid">
            <div class="d-flex align-items-center " href="#"> 
                <img src="../assets/img/person.svg" alt="" width="46" height="46" class="d-inline-block align-text-top rounded-circle border border-2 border-white">
                <div class="ms-3 text-white ">{{ officer_name }}<br> <small>เจ้าหน้าที่เวรเปล: {{ officer.positionname }}</small>  </div>
            </div>
        </div>
    </nav>
</template>

<script>
export default {
    data () {
        return {
            officer_name: localStorage.getItem('officer_name'),
        }
    },
    props: {
        officer: {
            type: Object
        }
    },
    methods: {
        logout() {
            localStorage.removeItem('officer_id')
            localStorage.removeItem('device_id')
            this.$router.push('/login')
        }
    }
}
</script>

